import { Button, CircularProgress } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import { Colors, Spacing } from "../../config";
import { formConnector } from "../../FormConfig";
import FontStyle from "../styles/fontsStyles";

const StyledButton = styled(Button)(({ theme, $alternative, $color }) => {
  const { spacing, palette: colors } = theme;
  return {
    display: "flex",
    height: "fit-content",
    alignItems: "center",
    justifyContent: "center",
    padding: spacing(0.7, 2),
    flexShrink: 0,
    overflow: "hidden",
    textTransform: "uppercase",
    backgroundColor:
      $alternative || $color === 2
        ? Colors.carbon
        : $color === 1
        ? Colors.orange
        : Colors.red,

    ...FontStyle.semibold14,
    ".MuiButton-startIcon": {
      fill: colors.primary.contrastText,
      width: 17,
    },
    "&:disabled": {
      backgroundColor: colors.lightGray,
    },
    ":hover": {
      backgroundColor:
        $color === 2
          ? Colors.carbon
          : $color === 1
          ? Colors.carbon
          : Colors.carbon,
    },
  };
});

const StyledCircularProgress = styled(CircularProgress)(({ theme, $show }) => {
  const { palette: colors } = theme;
  return {
    position: "absolute",
    color: colors.secondary.main,
    transition: ".5s",
    opacity: $show ? 1 : 0,
  };
});

const ChildrenContainer = styled.div(({ $show }) => {
  return {
    transition: ".5s",
    opacity: $show ? 1 : 0.5,
  };
});

function ButtonContainedComponent({
  fullWidth = true,
  loading,
  children,
  type,
  disabled,
  name,
  alternative,
  color,
  ...props
}) {
  const {
    disabled: stateDisabled,
    onClick,
    ref,
  } = formConnector.useFormButton({
    type,
    disabled,
    name,
    color,
  });

  return (
    <StyledButton
      $alternative={alternative}
      variant="contained"
      color="primary"
      type={null}
      ref={ref}
      fullWidth={fullWidth}
      disabled={stateDisabled}
      onClick={onClick}
      $color={color}
      {...props}
    >
      <StyledCircularProgress size={Spacing(2.5)} $show={loading} />
      <ChildrenContainer $show={!loading}>{children}</ChildrenContainer>
    </StyledButton>
  );
}

export default ButtonContainedComponent;
